<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length">
				<h3 class="text-center red--text">مدرکی برای این نوع وام ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن مدرک
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3 pa-3" elevation="0"
					style="border: 1px solid #dca6e5">
					<v-card-text class="mb-2">
						<v-row class="d-flex">
							<v-col cols="12" md="11" class="py-0 my-0">
								<div class="text-h4">{{ item.authorizationItem.title }}</div>
								<div class="text-h6 grey--text"><span>{{
									getSystemType(item.authorizationItem.systemType) }}</span></div>
								<div class="text-h6 grey--text">{{ ![5, 6].includes(item.authorizationItem.systemType) ?
									item.authorizationItem.description : '' }}</div>
							</v-col>
							<v-col cols="12" md="1" class="my-0 py-0 d-flex align-center">
								<v-btn @click="remove(item, index)" :loading="loading" class="" x-small icon color="red"
									dark title="حذف">
									<v-icon>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
					<v-divider />
					<div>
						<v-radio-group v-model="item.isPrimary" @change="(x) => changeIsPrimary(x, item)" column>
							<v-radio class="small rtl"
								label="مدارک اولیه (مدارک اولیه در زمان ثبت درخواست باید توسط مشتری ارائه شوند)"
								color="secondary" :value="true"></v-radio>
							<v-radio class="small rtl"
								label="پس از ارزیابی (پس از ارزیابی توسط کارشناس به مدارک اضافه می شوند)"
								color="secondary" :value="false"></v-radio>
						</v-radio-group>
					</div>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن مدرک
					</v-btn>
				</div>
			</div>
		</div>
		<v-dialog v-model="dialog" scrollable persistent max-width="1000px">
			<AuthorizationItems @select="addSelection" v-if="dialog" @close="dialog = false" />
		</v-dialog>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'
	import { authorizationSystemTypes } from '@/util/enums'

	export default {
		name: 'LoanAuthorizationItems',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			AuthorizationItems: () => import('@/components/forms/AuthorizationItems.vue'),
		},
		data() {
			return {
				errorMessages: '',
				items: [],
				localData: {},
				submitLoading: false,
				loading: false,
				dialog: false,
				systemTypes: authorizationSystemTypes
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/LoanAuthorizationItem/ListByLoanId/' + this.data.id, null)
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								x.systemType = this.systemTypes.find(s => s.id == x.systemType)
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			getSystemType(type) {
				return this.systemTypes.find(x => x.id === type)?.title || ''
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/LoanAuthorizationItem/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.items.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				this.dialog = true
			},
			async addSelection(items) {
				this.dialog = false
				let itemsToAdd = []
				if (items?.length > 0) {
					itemsToAdd = items.filter(x => !this.items.some(i => i.authorizationItem.id === x.id))
				}

				if (!itemsToAdd.length)
					return

				this.loading = true
				for (let index = 0; index < itemsToAdd.length; index++) {
					let item = itemsToAdd[index]
					let data = {
						authorizationItem: { id: item.id, title: item.title },
						loan: { id: this.data.id },
					}
					await api.post('admin/LoanAuthorizationItem/create', data)
						.then(response => {
							toast.success(`آیتم ${item.title} با موفقیت اضافه شد.`)
							if (item.id === emptyId) {
								item.id = response
							}
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
				this.loadData()
			},
			changeIsPrimary(x, item) {
				item.isPrimary = x
				api.post('admin/LoanAuthorizationItem/edit', item)
					.then(response => {
					})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
	}
</script>
<style></style>
